import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import { getTopData } from "@/api/bizBillingdata";
import DataEmpty from "@/components/dataEmpty";
export default {
  name: "topChart",
  components: {
    DataEmpty: DataEmpty
  },
  props: {
    teamId: {
      type: Number,
      require: true
    },
    zone: String,
    dateRange: {
      type: Array,
      require: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '400px'
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      topDatas: [],
      qZone: this.zone,
      isTopDomain: false,
      loading: false
    };
  },
  methods: {
    backToZone: function backToZone() {
      this.qZone = '';
      // this.isTopDomain = false
      this.getTopDomain();
    },
    getChartWidth: function getChartWidth(count) {
      if (this.maxCount == 0) {
        return 0;
      }
      var wp = count / this.maxCount * 100;
      if (wp < 2) {
        wp = 2 + wp;
      }
      return wp;
    },
    getZone: function getZone(zone) {
      if (!this.qZone) {
        this.qZone = zone;
        this.getTopDomain();
      }
    },
    getTopDomain: function getTopDomain() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, top_data, _maxCount;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              params = {
                teamId: _this.teamId,
                zone: _this.qZone,
                start: new Date(_this.dateRange[0]).getTime() / 1000 | 0,
                end: new Date(_this.dateRange[1]).getTime() / 1000 | 0
              };
              _context.next = 4;
              return getTopData(params);
            case 4:
              top_data = _context.sent;
              _this.loading = false;
              if (top_data.code == 0) {
                _maxCount = 0;
                _this.topDatas = top_data.data.filter(function (data) {
                  if (data.count > _maxCount) {
                    _maxCount = data.count;
                  }
                  return data.name != '';
                });
                _this.maxCount = _maxCount;
                if (_this.qZone && _this.qZone != '') {
                  _this.isTopDomain = true;
                } else {
                  _this.isTopDomain = false;
                }
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  watch: {
    dateRange: function dateRange() {
      this.getTopDomain();
    },
    zone: function zone() {
      this.qZone = this.zone, this.getTopDomain();
    }
  },
  created: function created() {
    this.getTopDomain();
  }
};